import SwipeableDrawerWithBackNavigation from '@/src/components/common/ui/swipeableDrawer'
import PriceSummaryWrapper from '@/src/components/desktop/itinerary/priceSummary'
import { Box, Button, Typography } from '@mui/material'
import React from 'react'

interface ItineraryFooterProps {
    price: number
    breakupDrawerOpen: boolean
    isUpdateItineraryLoading?: boolean
    buttonCta?: string
    formatCurrency: (price: number) => string
    onContinue?: () => void
    toggleBreakupDrawer: () => void
    tCommon: (key: string) => string
}

const ItineraryFooter: React.FC<ItineraryFooterProps> = ({
    price,
    breakupDrawerOpen,
    isUpdateItineraryLoading,
    buttonCta,
    formatCurrency,
    onContinue,
    toggleBreakupDrawer,
    tCommon
}) => {
    return (
        <>
            <Box
                sx={{
                    position: 'relative',
                    left: 0,
                    bottom: 0,
                    width: '100vw',
                    bgcolor: 'transparent',
                    boxShadow: '0 -2px 8px rgba(0,0,0,0.04)'
                }}
            >
                {/* Bottom Row: Price and Continue Button */}
                <Box
                    sx={{
                        bgcolor: 'neutral.100',
                        px: 2,
                        py: 2,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between'
                    }}
                >
                    <Box>
                        <Typography fontWeight={700} fontSize={16} color="text.primary">
                            {formatCurrency(price)}
                        </Typography>
                        <Typography
                            fontSize={14}
                            fontWeight={600}
                            color="primary.main"
                            sx={{ cursor: 'pointer' }}
                            onClick={toggleBreakupDrawer}
                        >
                            {tCommon('viewBreakup')}
                        </Typography>
                    </Box>
                    <Button
                        variant="customVariantPrimary"
                        color="primary"
                        sx={{
                            borderRadius: 1,
                            minWidth: 120,
                            fontWeight: 700,
                            fontSize: 16,
                            boxShadow: '0px 2px 8px rgba(0,0,0,0.08)'
                        }}
                        onClick={onContinue}
                        loading={isUpdateItineraryLoading}
                    >
                        {buttonCta || tCommon('Continue')}
                    </Button>
                </Box>
            </Box>
            {/* Price Breakup Drawer */}
            <SwipeableDrawerWithBackNavigation
                anchor="bottom"
                open={breakupDrawerOpen}
                onClose={toggleBreakupDrawer}
                sx={{
                    height: 'auto'
                }}
            >
                <PriceSummaryWrapper />
            </SwipeableDrawerWithBackNavigation>
        </>
    )
}

export default ItineraryFooter
export type { ItineraryFooterProps }
